module.exports = __webpack_public_path__ + "bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bd.svg
// module id = 440
// module chunks = 0